import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import TableCellPropertyCommand from './tablecellpropertycommand.js';
/**
 * The table cell horizontal alignment command.
 *
 * The command is registered by the {@link module:table/tablecellproperties/tablecellpropertiesediting~TableCellPropertiesEditing} as
 * the `'tableCellHorizontalAlignment'` editor command.
 *
 * To change the horizontal text alignment of selected cells, execute the command:
 *
 * ```ts
 * editor.execute( 'tableCellHorizontalAlignment', {
 *  value: 'right'
 * } );
 * ```
 */
var TableCellHorizontalAlignmentCommand = /*#__PURE__*/function (_TableCellPropertyCom) {
  _inherits(TableCellHorizontalAlignmentCommand, _TableCellPropertyCom);
  var _super = _createSuper(TableCellHorizontalAlignmentCommand);
  /**
   * Creates a new `TableCellHorizontalAlignmentCommand` instance.
   *
   * @param editor An editor in which this command will be used.
   * @param defaultValue The default value for the "alignment" attribute.
   */
  function TableCellHorizontalAlignmentCommand(editor, defaultValue) {
    _classCallCheck(this, TableCellHorizontalAlignmentCommand);
    return _super.call(this, editor, 'tableCellHorizontalAlignment', defaultValue);
  }
  return TableCellHorizontalAlignmentCommand;
}(TableCellPropertyCommand);
export { TableCellHorizontalAlignmentCommand as default };